// extracted by mini-css-extract-plugin
module.exports = {"page-count":"Page_page-count__1E0US","hide":"Page_hide__2lHIe"};